import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../../state/reducers';
import SocialIcon from '../../../SocialIcon';
import {
  IProps,
  IStateProps,
} from './interfaces';
import {
  DialogHeader,
  DialogHeaderTitle,
} from '../../../styles/dialog';

class SocialDialogHeader extends React.Component<IProps> {
  render() {
    const {
      socialPublishing: {
        settings: publishSettings,
      },
      children,
    } = this.props;

    return (
      <DialogHeader
        data-auto={`${publishSettings.type}Dialog`}
      >
        <DialogHeaderTitle>
          <SocialIcon type={publishSettings.type} />
          {children}
        </DialogHeaderTitle>
      </DialogHeader>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
});

export default connect(
  mapStateToProps,
)(SocialDialogHeader);
